<style lang="sass">
  @import '../node_modules/typeface-roboto/index.css'
</style>

<template>
  <v-app id="inspire">
    <v-navigation-drawer
      v-model="drawer"
      v-if="logIn"
      :clipped="$vuetify.breakpoint.lgAndUp"
      app
    >
      <v-list dense>
        <!-- Home. <<Ini>> -->
         <template v-if="isAdminAll || isAdminCustoms 
         || isCustoms || isYMS || isProduction || isIPQC || isDell_SAP || isPE || isDell_PAPERPILOT
         || isSOPAdmin || isME"> 
            <v-list-item to="/" link>
                <v-list-item-icon>
                  <v-icon>home</v-icon>
                </v-list-item-icon>  
                <v-list-item-title>Home</v-list-item-title>
            </v-list-item>
         </template> 
        <!-- Home. <<End>> -->

       <!--SOP [ini] -->
          <template  v-if="isAdminAll || isSOPAdmin  ">
            <v-list-group  no-action  prepend-icon="apps" value="true">     
              <template v-slot:activator>
                <v-list-item-title>Administrator</v-list-item-title>
              </template> 
              <v-list-item v-for="(item, i) in dellSOPWorkflow" :key="i" @click="" :to="item[2]" link>
                  <v-list-item-title v-text="item[0]"></v-list-item-title>
                  <v-list-item-action>
                    <v-icon  v-text="item[1]"></v-icon>
                  </v-list-item-action>
                </v-list-item>             
              </v-list-group>
          </template>    

          <template  v-if="isAdminAll || isSOPAdmin || isME ">
            <v-list-group  no-action  prepend-icon="apps" value="true">     
              <template v-slot:activator>
                <v-list-item-title>ME Engineer</v-list-item-title>
              </template> 
              <v-list-item v-for="(item, i) in dellSOPME" :key="i" @click="" :to="item[2]" link>
                  <v-list-item-title v-text="item[0]"></v-list-item-title>
                  <v-list-item-action>
                    <v-icon  v-text="item[1]"></v-icon>
                  </v-list-item-action>
                </v-list-item>             
              </v-list-group>
          </template>    
           <template  v-if="isAdminAll || isSOPAdmin || isME || isProduction ">
            <v-list-group  no-action  prepend-icon="apps" value="true">     
              <template v-slot:activator>
                <v-list-item-title>Production</v-list-item-title>
              </template> 
              <v-list-item v-for="(item, i) in dellSOPProduction" :key="i" @click="" :to="item[2]" link>
                  <v-list-item-title v-text="item[0]"></v-list-item-title>
                  <v-list-item-action>
                    <v-icon  v-text="item[1]"></v-icon>
                  </v-list-item-action>
                </v-list-item>             
              </v-list-group>
          </template>    
       <!--SOP [end] -->

        <!-- DELL [Ini] -->
          <template  v-if="isDell_PAPERPILOT  ">
            <v-list-group  no-action  prepend-icon="apps" value="true">     
              <template v-slot:activator>
                <v-list-item-title>DELL</v-list-item-title>
              </template> 
              <v-list-item v-for="(item, i) in dellPaperPilot" :key="i" @click="" :to="item[2]" link>
                  <v-list-item-title v-text="item[0]"></v-list-item-title>
                  <v-list-item-action>
                    <v-icon  v-text="item[1]"></v-icon>
                  </v-list-item-action>
                </v-list-item>             
              </v-list-group>
          </template>    

           <template  v-if="isAdminAll || isDell_SAP  ">
            <v-list-group  no-action  prepend-icon="apps" value="true">     
              <template v-slot:activator>
                <v-list-item-title>DELL</v-list-item-title>
              </template> 
              <v-list-item v-for="(item, i) in dellSAPItems" :key="i" @click="" :to="item[2]" link>
                  <v-list-item-title v-text="item[0]"></v-list-item-title>
                  <v-list-item-action>
                    <v-icon  v-text="item[1]"></v-icon>
                  </v-list-item-action>
                </v-list-item>             
              </v-list-group>
          </template>    

          <template v-if="isAdminAll || isPE">
              <v-list-group sub-group no-action >
                <template v-slot:activator>
                  <v-list-item-content>
                    <v-list-item-title>P E</v-list-item-title>
                  </v-list-item-content>
                </template>
                <v-list-item v-for="(item, i) in peItems" :key="i" @click="" :to="item[2]" link>
                  <v-list-item-title v-text="item[0]"></v-list-item-title>
                  <v-list-item-action>
                    <v-icon  v-text="item[1]"></v-icon>
                  </v-list-item-action>
                </v-list-item>
              </v-list-group>
            </template>
         <!-- DELL [End] -->


        <!-- YMS Invoice. <<Ini>> -->
           <template  v-if="isAdminAll || isAdminCustoms || isCustoms || isYMS ">
            <v-list-group  no-action  prepend-icon="drive_eta" value="true">     
              <template v-slot:activator>
                <v-list-item-title>YMS</v-list-item-title>
              </template> 
              <v-list-item v-for="(item, i) in ymsCumtomsItems" :key="i" @click="" :to="item[2]" link>
                  <v-list-item-title v-text="item[0]"></v-list-item-title>
                  <v-list-item-action>
                    <v-icon  v-text="item[1]"></v-icon>
                  </v-list-item-action>
                </v-list-item>             
              </v-list-group>
          </template>
        <!-- YMS Invoice. <<End>> -->


        <!-- Quality Defect System. <<Ini>> -->
        <template  v-if="isAdminAll  || isIPQC">
          <v-list-group  prepend-icon="notification_important" value="true" >      

            <template v-slot:activator>
              <v-list-item-title>Quality Defect</v-list-item-title>
            </template>  

            <template v-if="isAdminAll  ">
              <v-list-group no-action sub-group value="true">
                <template v-slot:activator>
                  <v-list-item-content>
                    <v-list-item-title>Production</v-list-item-title>
                  </v-list-item-content>
                </template>  
                <v-list-item v-for="(item, i) in prdItems" :key="i" @click="" :to="item[2]" link>
                  <v-list-item-title v-text="item[0]"></v-list-item-title>
                  <v-list-item-action>
                    <v-icon  v-text="item[1]"></v-icon>
                  </v-list-item-action>
                </v-list-item>
              </v-list-group>
            </template>

            <template v-if="isAdminAll ||  isIPQC">
              <v-list-group sub-group no-action >
                <template v-slot:activator>
                  <v-list-item-content>
                    <v-list-item-title>IPQC</v-list-item-title>
                  </v-list-item-content>
                </template>
                <v-list-item v-for="(item, i) in ipqcItems" :key="i" @click="" :to="item[2]" link>
                  <v-list-item-title v-text="item[0]"></v-list-item-title>
                  <v-list-item-action>
                    <v-icon  v-text="item[1]"></v-icon>
                  </v-list-item-action>
                </v-list-item>
              </v-list-group>
            </template>
          
          
          
            <template v-if="isAdminAll || isIPQC">
              <v-list-group sub-group no-action >
                <template v-slot:activator>
                  <v-list-item-content>
                    <v-list-item-title>ME</v-list-item-title>
                  </v-list-item-content>
                </template>
                <v-list-item v-for="(item, i) in meItems" :key="i" @click="" :to="item[2]" link>
                  <v-list-item-title v-text="item[0]"></v-list-item-title>
                  <v-list-item-action>
                    <v-icon  v-text="item[1]"></v-icon>
                  </v-list-item-action>
                </v-list-item>
              </v-list-group>
            </template>

            <template v-if="isAdminAll || isIPQC">
              <v-list-group sub-group no-action >
                <template v-slot:activator>
                  <v-list-item-content>
                    <v-list-item-title>MRB</v-list-item-title>
                  </v-list-item-content>
                </template>
                <v-list-item v-for="(item, i) in mrbItems" :key="i" @click="" :to="item[2]" link>
                  <v-list-item-title v-text="item[0]"></v-list-item-title>
                  <v-list-item-action>
                    <v-icon  v-text="item[1]"></v-icon>
                  </v-list-item-action>
                </v-list-item>
              </v-list-group>
            </template>

            <template v-if="isAdminAll || isIPQC">
              <v-list-group sub-group no-action >
                <template v-slot:activator>
                  <v-list-item-content>
                    <v-list-item-title>SQE</v-list-item-title>
                  </v-list-item-content>
                </template>
                <v-list-item v-for="(item, i) in sqeItems" :key="i" @click="" :to="item[2]" link>
                  <v-list-item-title v-text="item[0]"></v-list-item-title>
                  <v-list-item-action>
                    <v-icon  v-text="item[1]"></v-icon>
                  </v-list-item-action>
                </v-list-item>
              </v-list-group>
            </template>

            <template v-if="isAdminAll || isIPQC">
              <v-list-group sub-group no-action >
                <template v-slot:activator>
                  <v-list-item-content>
                    <v-list-item-title>NPI</v-list-item-title>
                  </v-list-item-content>
                </template>
                <v-list-item v-for="(item, i) in npiItems" :key="i" @click="" :to="item[2]" link>
                  <v-list-item-title v-text="item[0]"></v-list-item-title>
                  <v-list-item-action>
                    <v-icon  v-text="item[1]"></v-icon>
                  </v-list-item-action>
                </v-list-item>
              </v-list-group>
            </template>

            <template v-if="isAdminAll || isIPQC">
              <v-list-group sub-group no-action >
                <template v-slot:activator>
                  <v-list-item-content>
                    <v-list-item-title>Dismantel</v-list-item-title>
                  </v-list-item-content>
                </template>
                <v-list-item v-for="(item, i) in dismantelItems" :key="i" @click="" :to="item[2]" link>
                  <v-list-item-title v-text="item[0]"></v-list-item-title>
                  <v-list-item-action>
                    <v-icon  v-text="item[1]"></v-icon>
                  </v-list-item-action>
                </v-list-item>
              </v-list-group>
            </template>

          
            <template v-if="isAdminAll || isIPQC">
            <v-list-group sub-group no-action >
              <template v-slot:activator>
                <v-list-item-content>
                  <v-list-item-title>Maintenance</v-list-item-title>
                </v-list-item-content>
              </template>
              <v-list-item v-for="(item, i) in mantenanceItems" :key="i" @click="" :to="item[2]" link>
                <v-list-item-title v-text="item[0]"></v-list-item-title>
                <v-list-item-action>
                  <v-icon  v-text="item[1]"></v-icon>
                </v-list-item-action>
              </v-list-item>
            </v-list-group>
            </template>

            <template v-if="isAdminAll || isIPQC">
              <v-list-group sub-group no-action >
                <template v-slot:activator>
                  <v-list-item-content>
                    <v-list-item-title>WHS</v-list-item-title>
                  </v-list-item-content>
                </template>
                <v-list-item v-for="(item, i) in whsItems" :key="i" @click="" :to="item[2]" link>
                  <v-list-item-title v-text="item[0]"></v-list-item-title>
                  <v-list-item-action>
                    <v-icon  v-text="item[1]"></v-icon>
                  </v-list-item-action>
                </v-list-item>
              </v-list-group>
            </template>

            <template v-if="isAdminAll || isIPQC">
              <v-list-group sub-group no-action >
                <template v-slot:activator>
                  <v-list-item-content>
                    <v-list-item-title>IQC</v-list-item-title>
                  </v-list-item-content>
                </template>
                <v-list-item v-for="(item, i) in iqcItems" :key="i" @click="" :to="item[2]" link>
                  <v-list-item-title v-text="item[0]"></v-list-item-title>
                  <v-list-item-action>
                    <v-icon  v-text="item[1]"></v-icon>
                  </v-list-item-action>
                </v-list-item>
              </v-list-group>
            </template>

          </v-list-group>
        </template>
        <!-- Quality Defect System. <<End>> -->

        <!-- System. <<Ini>> -->
       <template  v-if="isAdminAll">
         <v-list-group no-action  prepend-icon="account_circle" value="true"  >
            <template v-slot:activator>
              <v-list-item-content>
                <v-list-item-title>User</v-list-item-title>
              </v-list-item-content>
            </template>  
            <v-list-item v-for="(item, i) in userItems" :key="i" @click="" :to="item[2]" link>
              <v-list-item-title v-text="item[0]"></v-list-item-title>
              <v-list-item-action>
                <v-icon  v-text="item[1]"></v-icon>
              </v-list-item-action>
            </v-list-item>
          </v-list-group>
        </template>
        <!-- System. <<End>> -->
      
      
        </v-list>


    </v-navigation-drawer>

    <v-app-bar
      :clipped-left="$vuetify.breakpoint.lgAndUp"
      app
      color="blue darken-3"
      dark
      
    >
      <v-app-bar-nav-icon @click.stop="drawer = !drawer" />
      <v-toolbar-title style="width: 300px" class="ml-0 pl-4" >
        <span class="hidden-sm-and-down">PCEPortal</span>
      </v-toolbar-title>
      
      <v-spacer />

      <v-btn @click="exitApp" v-if="logIn" icon>
        <v-icon>logout</v-icon> Exit
      </v-btn>
       <v-btn :to="{name: 'Login'}" v-else>
        <v-icon>apps</v-icon> LogIn
      </v-btn>
    
    
    </v-app-bar>




    <!--<v-content>-->
    <v-main>
      <v-container class="fill-height" fluid >
       
        <v-slide-y-transition mode="out-in">
          <router-view/>
        </v-slide-y-transition>
      
      </v-container>
      </v-main>
    <!--</v-content>-->

  <template>
  <v-footer
    color="primary lighten-1"
    padless
  >
    <v-row
      justify="center"
      no-gutters
    >
    
      <v-btn
        v-for="link in links"
        :key="link.name"
        color="white"
        text
        rounded
        class="my-2"
        :to="link.href"
      >
        {{ link.name }}
      </v-btn>


      <v-col
        class="primary lighten-2 py-4 text-center white--text"
        cols="12"
      >
        {{ new Date().getFullYear() }} — <strong>PCE Technology de Juárez S.A. de C.V </strong>
      </v-col>
    </v-row>
  </v-footer>
</template>
   
  </v-app>
</template>

<script>


export default {
  name: 'App',

 
data: () => ({
   drawer: null,
     dellSOPWorkflow: [       
      ['Area', 'list','/AreaSOP'],
      ['Line type', 'list','/LineSOP'],
      ['LOB', 'list','/LobSOP'],
      ['Email', 'list','/Contact'],
      ['WorkFlow', 'list','/WorkFlowSOP']
     ],
     dellSOPME: [
      ['Signatures', 'list','/Signatures'],
      ['Dashboard', 'list','/Dashboard'],
      ['SOP', 'list','/MESOP']
     ],
      dellSOPProduction: [
      ['SOP', 'list','/ProductionSOP']
     ],
     dellPaperPilot: [
      ['Paper Pilots', 'list','/PaperPilot']
     ],
     dellSAPItems: [
      ['Paper Pilots', 'list','/PaperPilot'],
      ['Automatic MOD', 'list','/ModProjectDell'] 
    ],
    ymsCumtomsItems: [
      ['Manzanillo Invoice', 'view_list','/Invoice']      
    ],
    prdItems: [
      ['Add an Issue', 'add_circle','/Issue']      
    ],
    ipqcItems: [
      ['List of issues', 'view_list','/Issue']      
    ],
    peItems: [
      ['Alternative PN', 'view_list','/AlternativePN'],
      ['MC Code', 'view_list','/MaterialGroup'],
      ['Issues in SAP', 'view_list','/ModProjectPE']    
    ],
    meItems: [
      ['List of issues', 'view_list','/Issue']      
    ],
    mrbItems: [
      ['List of issues', 'view_list','/Issue']      
    ],
    sqeItems: [
      ['List of issues', 'view_list','/Issue']      
    ],
    npiItems: [
      ['List of issues', 'view_list','/Issue']      
    ],
    dismantelItems: [
      ['List of issues', 'view_list','/Issue']      
    ],
    mantenanceItems: [
      ['List of issues', 'view_list','/Issue']      
    ],
    whsItems: [
      ['List of issues', 'view_list','/Issue']      
    ],
    iqcItems: [
      ['List of issues', 'view_list','/Issue']      
    ],   
    userItems: [
      ['Roles', 'group_add','/Roles'],
      ['Users', 'person_add','']       
    ],
      links: [
        {
          name: 'Home',
          href: '/'
        },
        {
          name: 'About Us',
          href: '/Issue'
        },
        {
          name: 'Team',
          href: '/'
        },
        {
          name: 'Services',
          href: '/'
          },
        {
          name: 'Blog',
          href: '/'
          },
        {
          name: 'Contact Us',
          href: '/'
          },
      ],
    }),
    computed: {
      logIn(){
        return this.$store.state.user;
      },

      /*** 2021 ISG Digitize SOP [Ini]  ***/
      isSOPAdmin(){
        return this.$store.state.user && this.$store.state.user.rol == 'sop_admin_dfms';
      },
      /*** 2021 ISG Digitize SOP [End]  ***/


      /*** Rol Super Admin [Ini]***/
      isAdminAll(){
        return this.$store.state.user && this.$store.state.user.rol == 'administrator_all';
      },
      /*** Rol Super Admin [End]***/

      /*** Roles for Customs [Ini]***/
      isAdminCustoms(){
         return this.$store.state.user && this.$store.state.user.rol == 'administrator_customs';
      },
      isCustoms(){
         return this.$store.state.user && this.$store.state.user.rol == 'custom_customs';
      },
      isYMS(){
         return this.$store.state.user && this.$store.state.user.rol == 'yms_customs';
      },      
      /*** Roles for Customs [End]***/


       /*** Roles for DELL [Ini]***/
      isDell_PAPERPILOT(){
         return this.$store.state.user && this.$store.state.user.rol == 'paperpilot_dell';
      },    
      isDell_SAP(){
         return this.$store.state.user && this.$store.state.user.rol == 'sap_dell';
      },     
      isProduction(){
         return this.$store.state.user && this.$store.state.user.rol == 'production_dfms';
      },
      isIPQC(){
         return this.$store.state.user && this.$store.state.user.rol == 'ipqc_dfms';
      },
      isPE(){
         return this.$store.state.user && this.$store.state.user.rol == 'pe_dfms';
      },
      isME(){
         return this.$store.state.user && this.$store.state.user.rol == 'me_dfms';
      }

      /*** Roles for DELL [End]***/

    },
    created(){
      this.$store.dispatch("autoLogin");
    },
    methods:{
        exitApp(){
          this.$store.dispatch("exit");
        }
    }
   
};
</script>
